export default __webpack_public_path__ + "static/media/createBackground.860a9025.jpg";